import { create } from "zustand";

export const useImageSliderStore = create((set, get) => ({
  data: {},
  image: undefined,
  setData: (value, isUndo = false, isRedo = false) => {
    const currentData = get().data;
    const newData = { ...currentData, ...value };

    if (!isUndo && !isRedo) {
      get().pushToHistory(newData);
    }

    set(() => ({
      data: newData,
    }));
  },
  setImage: (value) => set({ image: value }),
  updateImage: ({ id, key, value }) =>
    set((state) => {
      const updatedImages = state.data.images.map((img) =>
        img.id === id ? { ...img, [key]: value } : img
      );

      const updatedImage =
        state.image && state.image.id === id
          ? { ...state.image, [key]: value }
          : state.image;

      return {
        data: {
          ...state.data,
          images: updatedImages,
        },
        image: updatedImage,
      };
    }),

  updateImageMultipleProps: ({ id, value }) =>
    set((state) => {
      const updatedImages = state.data.images.map((img) =>
        img.id === id ? { ...img, ...value } : img
      );

      const updatedImage =
        state.image && state.image.id === id
          ? { ...state.image, ...value }
          : state.image;

      return {
        data: {
          ...state.data,
          images: updatedImages,
        },
        image: updatedImage,
      };
    }),

  getData: () => get().data,

  moveImage: (id, direction) => {
    set((state) => {
      const index = state.data.images.findIndex((item) => item.id === id);
      if (index === -1) return state;

      let newIndex = direction === "left" ? index - 1 : index + 1;
      if (newIndex < 0 || newIndex >= state.data.images.length) return state;

      const updatedData = [...state.data.images];
      const [moveImage] = updatedData.splice(index, 1);
      updatedData.splice(newIndex, 0, moveImage);

      get().pushToHistory({
        data: updatedData,
      });

      return { data: { ...state.data, images: updatedData } };
    });
  },

  position: 0,
  updatePosition: (value) => {
    set(() => ({
      position: value,
    }));
  },

  history: [],
  pushToHistory: (value) => {
    const newHistory = [...get().history, value];

    set(() => ({
      history: newHistory,
      position: newHistory.length - 1,
    }));
  },

  undo: () => {
    const { history, position, setData } = get();
    setData(
      {
        ...history[position - 1],
      },
      true,
      false
    );
    set({ position: position - 1 });
  },
  redo: () => {
    const { history, position, setData } = get();
    setData(
      {
        ...history[position + 1],
      },
      false,
      true
    );
    set({ position: position + 1 });
  },

  canUndo: () => {
    const { position } = get();
    return position > 0;
  },
  canRedo: () => {
    const { history, position } = get();
    return position < history.length - 1;
  },

  resetStore: () => {
    set({
      data: {},
      image: undefined,
      position: 0,
      history: [],
    });
  },
}));
